/**
 * Formats a date string to a specified locale and format.
 *
 * @param {string} date - The date string to format.
 * @param {string} [locale='en-US'] - The locale to use for formatting.
 * @param {Intl.DateTimeFormatOptions} [options] - The options for date format.
 * @returns {string} Formatted date string.
 */
export function formatCurrency(value: number | string): number {
  if (typeof value === 'string') {
    const cleaned = value.replace(/[^0-9.-]+/g, '')

    return parseFloat(cleaned)
  }
  return value
}

export function formatToCurrency(value: string | number): string {
  if (typeof value === 'string') {
    value = formatCurrency(value)
  }

  const n = Number(value)
  const abs = Math.abs(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return (n < 0 ? '-' : '') + '$' + abs
}
